import {Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from 'src/environments/environment';
import {v4 as uuid} from "uuid";
import {ApiCalls} from '../constants/api-constants';
import {StorageService} from './storage.service';
import {AccountDetailsResponse, AccountListResponse, AccountSubscriptionsResponse} from '../model/accounts.model';
import {map} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AccountSelectionService {
  constructor(private http: HttpClient, private storageService: StorageService) {
  }

  public getAccountSubscriptions() {
    const path = this.createUrl(ApiCalls.accountSelection.subscriptions);
    const header = this.buildHeader();
    return this.http.get<AccountSubscriptionsResponse>(path, {headers: header, withCredentials: true})
      .pipe(
        map(res => {
          this.handleResponseError(res);
          return res
        })
      );
  }


  public getAccountList() {
    const path = this.createUrl(ApiCalls.accountSelection.accountList);
    const header = this.buildHeader();
    return this.http.get<AccountListResponse>(path, {headers: header, withCredentials: true})
      .pipe(
        map(res => {
          this.handleResponseError(res);
          return res
        })
      );
  }

  public getAccountDetails(accountAlias, accountTypeNumber?: string) {
    const getAccountDetailsURL = ApiCalls.accountSelection.accountDetails.replace('{account-alias}', accountAlias);
    const fullURL = this.createUrl(getAccountDetailsURL);
    const opt = {
      accountTypeNumber: accountTypeNumber,
      authN: this.storageService.getAuthNToken(),
      authZ: this.storageService.getAuthZToken()
    }
    const header = this.buildHeader(opt);
    return this.http.get<AccountDetailsResponse>(fullURL, {headers: header, withCredentials: true})
      .pipe(
        map(res => {
          this.handleResponseError(res);
          return res
        })
      );
  }

  private handleResponseError(res: AccountSubscriptionsResponse) {
    if (!res?.status?.code.includes("200")) {
      throw new Error("Status: " + res?.status?.code?.substring(0, 3));
    }
  }

  // public isIPTVSubcribe(accounts: any, selectedAccount: any) {
  //   const selectedAccountDetails = accounts.find((element: any) => {
  //     return element.accountNumber === (selectedAccount as string);
  //   });
  //   const isIPTVSubscribed = selectedAccountDetails.subscriptions.filter(
  //     (element: any) => {
  //       return (
  //         element.subType === Subscription.subType &&
  //         element.status === Subscription.status
  //       );
  //     }
  //   );
  //   if (selectedAccountDetails && isIPTVSubscribed.length > 0) {
  //     return true;
  //   }
  //   return false;
  // }

  private buildHeader(opt?: any) {
    let headers = new HttpHeaders();
    headers = headers.append('x-app-id', 'Rogers.com')
    headers = headers.append('x-app-name', 'rogers-web')
    headers = headers.append('x-transaction-id', this.getTransactionId())
    headers = headers.append('realm', 'Rogers');

    if (opt && opt.accountTypeNumber) {
      headers = headers.append('accountTypeNumber', opt.accountTypeNumber);
    }
    if (opt && opt.authN) {
      headers = headers.append('AuthN', opt.authN);
    }
    if (opt && opt.authZ) {
      headers = headers.append('AuthZ', opt.authZ);

    }
    return headers;
  }

  private getTransactionId() {
    return uuid();
  }

  private createUrl(apiURL: string) {
    let envType = environment.name;
    let baseUrl = environment.microServices.baseUrl;
    let env =
      /(?:qa|dev|env|pet)\d{1,2}/g.exec(window.location.hostname)?.[0] ??
      'localhost';
    if (env.includes('qa')) {
      baseUrl = 'https://{{environment}}-mservices.rogers.com';
      envType = 'qa';
    }
    if (envType === 'prod') env = '';
    env = env.replace(/qa(\d)$/, 'qa0$1');
    env = env.replace(/pet(\d)$/, 'pet0$1');
    return baseUrl.replace('{{environment}}', env) + apiURL;
  }
}
